import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './ButtonLoader.scss'

import { Fade } from '../Transitions'

const ButtonLoader = ({ size }) => {
	return (
		<div
			styleName="loader"
			style={{ width: size || '20px', height: size || '20px' }}
		>
			<Fade>
				<div styleName="circle1" />
				<div styleName="circle2" />
			</Fade>
		</div>
	)
}

export default CSSModules(ButtonLoader, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Loader/ButtonLoader.js